export const isPrivate = process.env.VUE_APP_DOMAIN.includes(
  "gunma-suigai-risk.jp"
);

export const mytimelineUrl =
  process.env.NODE_ENV === "production"
    ? "https://mytimeline.suibou-gunma.jp"
    : "https://d1wzyc3vxzlg32.cloudfront.net";
